"use client"

import React, { useRef } from "react"
import Swal from "sweetalert2"
import { TimePicker } from "rsuite"
import "rsuite/TimePicker/styles/index.css"
import "./index.css"
import authAxios from "../../services/Token"
import hoy from "../../services/FechaActual"
import { useParams, Link } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faClipboardCheck,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
  faEdit,
  faFilter,
  faPlus,
  faTrashAlt,
  faImage,
  faInfo,
  faEye,
  faDownload,
  faUpload,
  faPrint,
  faSearch,
  faKey,
  faGasPump,
  faFileInvoice,
  faDollarSign,
  faSpinner,
  faTimes
} from "@fortawesome/free-solid-svg-icons"
import { saveAs } from "file-saver"
import FormularioCrear from "./Crear"
import { DownloadTableExcel } from "react-export-table-to-excel"
import $ from "jquery"
import { PDFViewer } from "@react-pdf/renderer"
import PDF from "./VerPdf"
import axios from "axios"
import Url, { apiImage } from "../../services/Api"
import { format } from "date-fns"
import PDFDetalle from "./DetallePdf"
import { eachDayOfInterval } from "date-fns"

const Index = ({ id = 14 }) => {
  var { idmenu } = useParams() || { idmenu: id };
  if (idmenu == undefined) {
    idmenu = 14
  }

  const tableRef = useRef(null)
  const tableHeader = useRef(null)
  const [isLoading, setIsLoading] = React.useState(false)
  const [isLoadingOpen, setIsLoadingOpen] = React.useState(false)
  const [isLoadingTable, setIsLoadingTable] = React.useState(false)
  const [pdfBase64, setPdfBase64] = React.useState("")
  const [ItemTabla, setLista] = React.useState([])
  const [ItemTablaExp, setListaExp] = React.useState([])
  const [Tabla, setTabla] = React.useState([])
  const [TablaModal, setTablaModal] = React.useState([])
  const [TablaExp, setTablaExp] = React.useState([])
  const [Tabs, setTab] = React.useState([])
  const [Relaciones, setRelaciones] = React.useState([])
  const [Titulo, setTitulo] = React.useState("Cargando..")
  const [CantidadParece, setCantidadParece] = React.useState(false)
  const [actual, setActual] = React.useState("1")
  const [ultimo, setUltimo] = React.useState("0")
  const [pagina, setPagina] = React.useState("0")
  const [Tamano, setTamano] = React.useState("lg")
  const [Configuracion, setConfiguracion] = React.useState([])
  const [VistaCampo, setVistaCampo] = React.useState("")
  const [RelacionItems, setRelacionItems] = React.useState("")

  const [Campo, setInput] = React.useState("")
  const [IdCampo, setInputId] = React.useState("")
  const [InputTabla, setInputTabla] = React.useState("")
  const [InputTablaId, setInputTablaId] = React.useState("")

  const [NombreTabla, setNombre] = React.useState("")
  const [botondescargar, setBoton] = React.useState("")
  const [Rel_Tabla, setRelTabla] = React.useState([])
  const [Rel_ItemTabla, setRelLista] = React.useState([])
  const [Rel_actual, setRelActual] = React.useState("1")
  const [Rel_ultimo, setRelUltimo] = React.useState("0")
  const [TabsRel, setRelTab] = React.useState([])
  const [Rel_nav, setPestana] = React.useState([])
  const [CampoSeleccionado, setCampoSeleccionado] = React.useState("")
  const [CampoFk, setCampoFk] = React.useState("")

  const [Foranea, setForanea] = React.useState("")
  const [Llave, setLlave] = React.useState("")
  const [Menu, setMenu] = React.useState("")
  const [TraeValue, setValor] = React.useState("")
  const [RelacionId, setRelacionId] = React.useState("")
  const [Boton, setVerBoton] = React.useState("0")
  const [Detalles, setDetalles] = React.useState([])

  const [showPdfModal, setShowPdfModal] = React.useState(false)
  const [selectedFuec, setSelectedFuec] = React.useState(null)
  const [showPdfDetailModal, setShowPdfDetailModal] = React.useState(false)

  const [IdUsuario, setIdUsuario] = React.useState("0")

  const [Vehiculos, setVehiculos] = React.useState([])
  const [TablaProgramacion, setTablaProgramacion] = React.useState([])
  const [TablaProgramacionEjecucion, setTablaProgramacionEjecucion] = React.useState([])
  const [elementosControl, setElementosControl] = React.useState([])

  //permisos
  const [Registrar, setRegistrar] = React.useState("0")
  const [Editar, setEditar] = React.useState("0")
  const [Eliminar, setEliminar] = React.useState("0")
  const [Cargar, setCargar] = React.useState("0")
  const [Consultar, setConsultar] = React.useState("0")
  const [BtnConfiguracionn, setBtnConfiguracion] = React.useState("0")
  const [InactivarBoton, setInactivarBoton] = React.useState(0)

  const [searchTerm, setSearchTerm] = React.useState("")
  const [selectAll, setSelectAll] = React.useState(false)
  const [selectedDate, setSelectedDate] = React.useState([])
  const [selectedTime, setSelectedTime] = React.useState("")
  const [events, setEvents] = React.useState([])
  const [selectedDates, setSelectedDates] = React.useState([])
  const [searchTerm1, setSearchTerm1] = React.useState("")
  const filteredItems = TablaModal.filter((item) =>
    String(item.nombre).toLowerCase().includes(searchTerm1.toLowerCase()),
  )
  const [time, setTime] = React.useState("")
  const [items, setItems] = React.useState([])
  const [searchTermsSec, setSearchTermsSec] = React.useState("")
  const [filteredData, setFilteredData] = React.useState([])
  const [showAdditionalFormsModal, setShowAdditionalFormsModal] = React.useState(false)
  const [additionalFormsCount, setAdditionalFormsCount] = React.useState(0)
  const [additionalFormsData, setAdditionalFormsData] = React.useState([])
  const [isCantidadHorasDisabled, setIsCantidadHorasDisabled] = React.useState(true)
  const [incrementPosition, setIncrementPosition] = React.useState(false)
  const [showTarifaModal, setShowTarifaModal] = React.useState(false)
  const [cargandoTarifas, setCargandoTarifas] = React.useState(false)
  const [tarifasCliente, setTarifasCliente] = React.useState([])
  const [filtroModalTarifa, setFiltroModalTarifa] = React.useState("")

  // NUEVAS FUNCIONES PARA CONTROLAR EL PDF
  const openPdfModal = async (idm, id) => {
    Swal.showLoading();
    try {
      const response = await authAxios.get(`master/ver/${idm}/${id}`);
      const datosRespuesta = response.data;

      if (datosRespuesta && datosRespuesta.result) {
        setSelectedFuec(datosRespuesta.result);
        setShowPdfModal(true);
      }
      Swal.close();
    } catch (error) {
      console.error("Error cargando datos del FUEC:", error);
      Swal.close();
      Swal.fire("Error", "No se pudo cargar el FUEC", "error");
    }
  };

  const closePdfModal = () => {
    setShowPdfModal(false);
    setSelectedFuec(null);
  };

  const openPdfDetailModal = async (idm, id) => {
    Swal.showLoading();
    try {
      const response = await authAxios.get(`master/ver/${idm}/${id}`);
      const datosRespuesta = response.data;

      if (datosRespuesta && datosRespuesta.result) {
        setSelectedFuec(datosRespuesta.result);
        setShowPdfDetailModal(true);
      }
      Swal.close();
    } catch (error) {
      console.error("Error cargando datos del FUEC:", error);
      Swal.close();
      Swal.fire("Error", "No se pudo cargar el FUEC", "error");
    }
  };

  const closePdfDetailModal = () => {
    setShowPdfDetailModal(false);
    setSelectedFuec(null);
  };

  const abrirModalTarifas = () => {
    const clienteId = document.getElementById("nombre_clientes")?.value;
    if (!clienteId) {
      Swal.fire({
        icon: 'warning',
        title: 'Cliente no seleccionado',
        text: 'Por favor seleccione un cliente primero para cargar sus tarifas'
      });
      return;
    }

    setShowTarifaModal(true);
    setCargandoTarifas(true);
    setTarifasCliente([]);
    setFiltroModalTarifa('');
    Swal.showLoading();
    const tipVehiculo = document.getElementById("tip_vehiculo")?.value || "";
    const modalidadId = document.getElementById("modalidad_nombre")?.value || "";
    const disponibilidad = document.getElementById("cantidad_modalidad")?.value || "";
    const produccionId = document.getElementById("produccion")?.value || "";

    const payload = {
        cliente_id: clienteId,
        vehiculo_id: tipVehiculo,
        modalidad_id: modalidadId,
        disponibilidad: disponibilidad,
        producciones_id: produccionId
    };

    authAxios.post("exterior/obtener-tarifas-cliente", payload)
      .then(res => {
        Swal.close();
        if (res.data && res.data.tarifas) {
          setTarifasCliente(res.data.tarifas);
        } else {
          setTarifasCliente([]);
        }
        setCargandoTarifas(false);
      })
      .catch(() => {
        Swal.close();
        setCargandoTarifas(false);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron consultar las tarifas del cliente'
        });
      });
  };

  const cerrarModalTarifas = () => {
    setShowTarifaModal(false);
    setFiltroModalTarifa('');
  };

  const seleccionarYActualizarTarifa = (tarifaItem) => {
    const tarifaBase = tarifaItem.valor_tarifa || tarifaItem.valor_sin_iva || 0;
    const costoTercero = tarifaItem.pago_conductor || tarifaItem.costo_tercero || 0;
    
    setFormValues(prev => ({
      ...prev,
      tarifa: tarifaItem.id,
      tarifa_base: tarifaBase,
      costo_tercero: costoTercero,
      valorServicio: tarifaBase,
      cantidad_horas: tarifaItem.horas || prev.cantidad_horas
    }));
    
    cerrarModalTarifas();
    Swal.fire({
      icon: 'success',
      title: 'Tarifa Seleccionada',
      timer: 1500,
      showConfirmButton: false
    });
  };

  const usir = localStorage.getItem("idusuario")

  // ESTADO INICIAL CON LOS NUEVOS CAMPOS
  const initialFormValues = {
    nombre_clientes: "",
    nombreCliente: "",
    ciudad: "",
    tip_vehiculo: "",
    estadoServicio: "",
    tarifa: "",
    tarifa_base: "",
    costo_tercero: "",
    tipoRecorrido: "",
    numeroContacto: "",
    valorServicio: "",
    numeroExpediente: "",
    fecha: "",
    horaInicial: "",
    direccionInicial: "",
    direccionFinal: "",
    cantidad: 1,
    obs: "",
    obs_int: "",
    items: [],
    telefonoUsuario: "",
    direccionUsuario: "",
    correoUsuario: "",
    apellidoUsuario: "",
    nombreUsuario: "",
    nombreLogistica: "",
    cargoLogistica: "",
    usuario: usir,
    produccion: "",
    cantidad_horas: "",
    cantidad_modalidad: "",
    tarifasDisponibles: [],
  }

  const [infoSeleccionada, setInfoSeleccionada] = React.useState([])
  const [formValues, setFormValues] = React.useState(initialFormValues)

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormValues({ ...formValues, [name]: value })
  }

  // FUNCIÓN PARA VALIDAR EL VALOR DEL SERVICIO
  const handleValorServicioBlur = async (e) => {
    const valorNegociado = parseFloat(e.target.value) || 0;
    const costoTercero = parseFloat(formValues.costo_tercero) || 0;
    const tarifaBase = parseFloat(formValues.tarifa_base) || 0;

    if (!formValues.tarifa || costoTercero === 0) {
      return;
    }

    if (valorNegociado > 0 && costoTercero > 0) {
      const utilidad = valorNegociado - costoTercero;
      const porcentajeUtilidad = (utilidad / valorNegociado) * 100;
      const valorMinimoPermitido = costoTercero / 0.85;
      const utilidadMinimaRequerida = valorNegociado * 0.15;

      if (porcentajeUtilidad < 15) {
        const result = await Swal.fire({
          icon: "warning",
          title: "¡Utilidad por debajo del 15%!",
          html: `
            <div style="text-align: left;">
              <p><strong>Utilidad actual:</strong> $${utilidad.toFixed(0)} (${porcentajeUtilidad.toFixed(1)}%)</p>
              <p><strong>Utilidad mínima requerida:</strong> $${utilidadMinimaRequerida.toFixed(0)} (15%)</p>
              <p><strong>Valor mínimo sugerido:</strong> $${valorMinimoPermitido.toFixed(0)}</p>
              <hr>
              <p>¿Deseas ajustar al valor sugerido?</p>
            </div>
          `,
          showCancelButton: true,
          confirmButtonText: 'Sí, ajustar',
          cancelButtonText: 'No, mantener',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          timer: 15000,
          timerProgressBar: true,
        });

        if (result.isConfirmed) {
          setFormValues({
            ...formValues,
            valorServicio: valorMinimoPermitido.toFixed(0)
          });
        }
      } else if (tarifaBase > 0 && valorNegociado > tarifaBase * 1.2) {
        const result = await Swal.fire({
          icon: "info",
          title: "Valor superior a la tarifa base",
          html: `
            <div style="text-align: left;">
              <p><strong>Tarifa base:</strong> $${tarifaBase.toFixed(0)}</p>
              <p><strong>Valor ingresado:</strong> $${valorNegociado.toFixed(0)}</p>
              <p><strong>Diferencia:</strong> $${(valorNegociado - tarifaBase).toFixed(0)} (${((valorNegociado - tarifaBase) / tarifaBase * 100).toFixed(1)}%)</p>
              <hr>
              <p>¿Confirmas este valor?</p>
            </div>
          `,
          showCancelButton: true,
          confirmButtonText: 'Sí, confirmar',
          cancelButtonText: 'No, revisar',
          timer: 15000,
          timerProgressBar: true,
        });

        if (!result.isConfirmed) {
          setFormValues({
            ...formValues,
            valorServicio: tarifaBase.toFixed(0)
          });
        }
      }
    }
  };

  // FUNCIÓN PARA MANEJAR CAMBIO DE TARIFA
  const handleTarifaChange = async (e) => {
    const tarifaId = e.target.value;
    if (!tarifaId) {
      setFormValues({ ...formValues, tarifa: '', tarifa_base: '', costo_tercero: '' });
      return;
    }

    const selectedTarifa = formValues.tarifasDisponibles.find(t => t.id == tarifaId);

    if (selectedTarifa) {
      const result = await Swal.fire({
        title: 'Confirmar tarifa',
        html: `El valor de la tarifa seleccionada es: <b>$${selectedTarifa.valor_sin_iva}</b><br>
               El costo del conductor es: <b>$${selectedTarifa.costo_tercero}</b><br>
               Utilidad estimada: <b>$${parseInt(selectedTarifa.valor_sin_iva) - parseInt(selectedTarifa.costo_tercero)} (${Math.round((parseInt(selectedTarifa.valor_sin_iva) - parseInt(selectedTarifa.costo_tercero)) / parseInt(selectedTarifa.valor_sin_iva) * 100)}%)</b><br>
               ¿Desea aplicar esta tarifa?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, aplicar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        timer: 10000,
        timerProgressBar: true,
      });

      if (result.isConfirmed) {
        setFormValues({
          ...formValues,
          tarifa: tarifaId,
          tarifa_base: selectedTarifa.valor_sin_iva,
          costo_tercero: selectedTarifa.costo_tercero,
          valorServicio: selectedTarifa.valor_sin_iva
        });
      }
    }
  }

  // FUNCIÓN PARA MANEJAR CAMBIO DE CLIENTE
  const handleClienteChange = async (id, nombre, tabla) => {
    if (tabla === "clientes") {
      // Resetear producción
      setFormValues(prevValues => ({
        ...prevValues,
        produccion: "",
        produccion_name: ""
      }));

      // Limpiar el campo de producción en el DOM
      const produccionNameInput = document.getElementById("produccion_name");
      if (produccionNameInput) {
        produccionNameInput.value = "";
      }

      const produccionInput = document.getElementById("produccion");
      if (produccionInput) {
        produccionInput.value = "";
      }

      // Resetear tarifas disponibles
      setFormValues(prevValues => ({
        ...prevValues,
        tarifasDisponibles: [],
        tarifa: "",
        tarifa_base: "",
        costo_tercero: "",
        valorServicio: ""
      }));
    }

    // Actualizar información seleccionada (sin producción)
    const nuevaSeleccion = [
      ...(infoSeleccionada ?? []).filter(item => item.tabla !== tabla && item.tabla !== "producciones"),
      { nombre, id, tabla }
    ];
    setInfoSeleccionada(nuevaSeleccion);

    // Actualizar el campo en el formulario
    document.getElementById(Campo).value = nombre;
    document.getElementById(IdCampo).value = id;

    // Si es cliente, no solicitar tarifas hasta que se seleccione producción
    if (tabla === "clientes") {
      return;
    }

    // Si es producción o tipo vehículo, solicitar tarifas
    if (tabla === "producciones" || tabla === "tip_vehiculo" || tabla === "modalidad_tari") {
      const payload = {
        infoSeleccionada: nuevaSeleccion,
        nombre,
        id,
        tabla
      };

      authAxios
        .post("master/relacion/tarifa", payload)
        .then((datosRespuesta) => {
          const { data } = datosRespuesta.data;
          setFormValues(prevValues => ({
            ...prevValues,
            tarifasDisponibles: data,
            tarifa: ""
          }));
        })
        .catch((error) => {
          console.error("Error al obtener las tarifas:", error);
        });
    }
  };

  const handleDateChange = (date) => {
    setSelectedDates((prevDates) => [...prevDates, date])
  }

  const [hours, minutes] = formValues.horaInicial.split(":")
  const initialDate = new Date()
  initialDate.setHours(Number.parseInt(hours, 10))
  initialDate.setMinutes(Number.parseInt(minutes, 10))

  const handleTimeChange = (time) => {
    const localTime = new Date(time)
    console.log(time)
    const hours = localTime.getHours().toString().padStart(2, "0")
    const minutes = localTime.getMinutes().toString().padStart(2, "0")
    const formattedTime = `${hours}:${minutes}`
    console.log(formattedTime)
    setFormValues({
      ...formValues,
      horaInicial: formattedTime,
    })
  }

  const handleAddItem = () => {
    if (selectedDates.length === 2) {
      const [startDate, endDate] = selectedDates
      const dateRange = eachDayOfInterval({
        start: startDate,
        end: endDate,
      })
      const newItems = dateRange.map((date) => ({
        date: format(date, "yyyy-MM-dd"),
        time,
      }))
      setItems((prevItems) => [...prevItems, ...newItems])
      setSelectedDates([])
      setTime("")
      setFormValues((prevValues) => ({
        ...prevValues,
        items: [...prevValues.items, ...newItems],
        time: "",
      }))
    } else {
      console.log("Por favor selecciona solo dos fechas")
    }
  }

  const clearNameFields = () => {
    const nameFields = document.querySelectorAll('[id$="_name"]')
    nameFields.forEach((field) => {
      field.value = ""
    })
  }

  const openModal = async () => {
    setShowAdditionalFormsModal(true)
  }

  const incrementarExpediente = (expediente) => {
    if (incrementPosition) {
      const match = expediente.match(/^(.*-)?(\d+)$/)
      if (match) {
        const prefix = match[1] || ""
        const position = Number.parseInt(match[2], 10)
        return `${prefix}${position + 10}`
      }
      return `${expediente}-10`
    } else {
      const match = expediente.match(/(\d+)(-\d+)?$/)
      if (match) {
        const numeroPrincipal = match[1]
        const sufijo = match[2] || ""
        const nuevoNumero = (Number.parseInt(numeroPrincipal, 10) + 1).toString().padStart(numeroPrincipal.length, "0")
        return expediente.replace(numeroPrincipal + sufijo, nuevoNumero + sufijo)
      }
      return `${expediente}1`
    }
  }

  // FUNCIÓN SAVEITEM MODIFICADA CON VALIDACIONES
  const saveItem = async () => {
    // Validación de tarifa seleccionada
    if (formValues.tarifa == '' || formValues.tarifa == null) {
      const result = await Swal.fire({
        icon: "warning",
        title: "Tarifa no seleccionada",
        text: "No existe una tarifa parametrizada para el cliente",
        confirmButtonColor: "#3085d6",
        timer: 8000,
        timerProgressBar: true,
      });
      return false;
    }

    // Validar que el valor del servicio no esté vacío
    if (!formValues.valorServicio) {
      await Swal.fire({
        icon: "warning",
        title: "Valor del servicio requerido",
        text: "Debes ingresar el valor del servicio",
        timer: 5000,
        timerProgressBar: true,
      });
      return;
    }

    // VALIDACIÓN DE UTILIDAD MÍNIMA (15%)
    const tarifaBase = parseFloat(formValues.tarifa_base) || 0;
    const valorNegociado = parseFloat(formValues.valorServicio) || 0;
    const costoTercero = parseFloat(formValues.costo_tercero) || 0;

    if (tarifaBase > 0 && costoTercero > 0 && valorNegociado > 0) {
      const utilidad = valorNegociado - costoTercero;
      const porcentajeUtilidad = (utilidad / valorNegociado) * 100;
      const valorMinimoPermitido = costoTercero / 0.85;
      const utilidadMinimaRequerida = valorNegociado * 0.15;

      if (porcentajeUtilidad < 15) {
        const result = await Swal.fire({
          icon: "warning",
          title: "¡Utilidad por debajo del 15%!",
          html: `
            <div style="text-align: left;">
              <p><strong>Utilidad actual:</strong> $${utilidad.toFixed(0)} (${porcentajeUtilidad.toFixed(1)}%)</p>
              <p><strong>Utilidad mínima requerida:</strong> $${utilidadMinimaRequerida.toFixed(0)} (15%)</p>
              <p><strong>Valor mínimo sugerido:</strong> $${valorMinimoPermitido.toFixed(0)}</p>
              <hr>
              <p>¿Estás seguro de continuar con este valor?</p>
            </div>
          `,
          showCancelButton: true,
          confirmButtonText: 'Sí, continuar',
          cancelButtonText: 'No, cancelar',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          timer: 15000,
          timerProgressBar: true,
        });

        if (!result.isConfirmed) {
          return;
        }
      }
    }

    Swal.showLoading();
    console.log("=== ENVIANDO DATOS AL BACKEND ===");
    console.log("Datos principales:", formValues);
    console.log("Formularios adicionales:", additionalFormsData);

    const utilidadCalculada = parseFloat(formValues.valorServicio) - parseFloat(formValues.costo_tercero || 0);
    const porcentajeUtilidadCalculada = parseFloat(formValues.valorServicio) > 0 ?
      (utilidadCalculada / parseFloat(formValues.valorServicio) * 100).toFixed(2) : 0;

    const dataToSend = {
      ...formValues,
      additionalForms: formValues.cantidad > 2 ? additionalFormsData : [],
      tarifa_base: formValues.tarifa_base,
      costo_tercero: formValues.costo_tercero,
      utilidad: utilidadCalculada,
      porcentaje_utilidad: porcentajeUtilidadCalculada
    };

    const formData = new FormData(document.getElementById("form_registro"));
    const allFormData = {};
    for (let [key, value] of formData.entries()) {
      allFormData[key] = value;
    }

    const finalData = {
      ...dataToSend,
      ...allFormData,
      aumentarPosicion: incrementPosition ? 1 : 0,
      usuario: localStorage.getItem("idusuario"),
      nombre_clientes: document.getElementById("nombre_clientes")?.value || "",
      ciudad_nombre: document.getElementById("ciudad_nombre")?.value || "",
      modalidad_nombre: document.getElementById("modalidad_nombre")?.value || "",
      tip_vehiculo: document.getElementById("tip_vehiculo")?.value || ""
    };

    console.log("Datos finales a enviar:", finalData);

    const fechaBase = new Date(finalData.fecha);

    if (finalData.cantidad > 2) {
      if (additionalFormsData.length == 0) {
        Swal.close();
        setAdditionalFormsCount(finalData.cantidad - 1);

        let expedienteActual = finalData.numeroExpediente;
        const nuevosFormularios = Array.from({ length: finalData.cantidad - 1 }, (_, index) => {
          const nuevaFecha = new Date(fechaBase);
          nuevaFecha.setDate(fechaBase.getDate() + (index + 1));
          const fechaFormateada = nuevaFecha.toISOString().split("T")[0];
          expedienteActual = incrementarExpediente(expedienteActual);

          return {
            ...finalData,
            fecha: fechaFormateada,
            numeroExpediente: expedienteActual,
          };
        });

        setCantidadParece(true);
        setAdditionalFormsData(nuevosFormularios);
        setShowAdditionalFormsModal(true);
        return;
      }
    }

    try {
      const dataToSend = {
        ...finalData,
        additionalForms: finalData.cantidad > 2 ? additionalFormsData : [],
      };

      console.log("Enviando al backend:", dataToSend);

      const response = await authAxios.post(`exterior/guardar-masivo-servicios-new`, dataToSend);
      console.log("Respuesta del backend:", response.data);

      const serviceIds = response.data.serviceIds;
      const tableHtml = `
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>ID del Servicio</th>
            </tr>
          </thead>
          <tbody>
            ${serviceIds.map((id) => `<tr><td>${id}</td></tr>`).join("")}
          </tbody>
        </table>
      `;

      setFormValues({
        ...initialFormValues,
        numeroExpediente: ''
      });
      clearNameFields();
      setAdditionalFormsData([]);
      setAdditionalFormsCount(0);
      setShowAdditionalFormsModal(false);
      setCantidadParece(false);
      setIsCantidadHorasDisabled(true);

      await Swal.fire({
        title: "Servicios",
        html: tableHtml,
        icon: "success",
        confirmButtonText: "Aceptar",
      });
    } catch (error) {
      console.error("Error guardando servicios:", error);
      await Swal.fire({
        title: "Error",
        text: "No se pudieron guardar los servicios",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    }
  };

  const handleCloseAdditionalFormsModal = () => {
    setShowAdditionalFormsModal(false)
  }

  const handleSaveAdditionalForms = () => {
    const formulariosIncompletos = additionalFormsData.some((formData, index) => {
      return (
        !formData.valorServicio ||
        !formData.fecha ||
        !formData.horaInicial ||
        !formData.direccionInicial ||
        !formData.direccionFinal
      )
    })

    if (formulariosIncompletos) {
      Swal.fire({
        icon: "error",
        title: "Formularios incompletos",
        text: "Por favor, completa todos los campos obligatorios en los formularios adicionales.",
      })
      return
    }

    console.log("Datos del formulario principal guardados:", formValues)
    console.log("Datos de los formularios adicionales guardados:", additionalFormsData)
    setShowAdditionalFormsModal(false)
    Swal.fire({
      icon: "success",
      title: "Guardado exitoso",
      text: "Los formularios adicionales se han guardado correctamente.",
    })
  }

  const handleSearch = (event) => {
    setSearchTerm(event.target.value)
  }

  const handleAdditionalFormInputChange = (index, e) => {
    const { name, value } = e.target
    const newAdditionalFormsData = [...additionalFormsData]
    newAdditionalFormsData[index] = {
      ...newAdditionalFormsData[index],
      [name]: value,
    }
    setAdditionalFormsData(newAdditionalFormsData)
  }

  const handleSelectAll = () => {
    setSelectAll(!selectAll)
  }

  const filteredVehiculos = Vehiculos.filter((vh) => vh.placa.toLowerCase().includes(searchTerm.toLowerCase()))

  const fetchPdf = async (id) => {
    Swal.showLoading()
    try {
      const response = await authAxios.post(`exterior/traer-factura/${id}`)
      const pdfData = response.data.response.base64
      setPdfBase64(pdfData)
      console.log("PDF base64:", pdfData)
      Swal.close()
      openPdfPopup()
    } catch (error) {
      console.error("Error fetching PDF:", error)
    }
  }

  const openPdfPopup = () => {
    const popupWindow = window.open("", "_blank", "width=800,height=600")
    if (popupWindow) {
      const pdfContent = `<iframe src="data:application/pdf;base64,${pdfBase64}" width="100%" height="100%"></iframe>`
      popupWindow.document.write(pdfContent)
    } else {
      console.error("Error opening popup window.")
    }
  }

  React.useEffect(() => {
    ListaTabla(idmenu, 1)
    ListaVehiculos()
  }, [idmenu])

  const ListaTabla = async (idm, page) => {
    Swal.showLoading()
    const form = document.getElementById("buscador")
    const u = localStorage.getItem("idusuario")
    const formData = new FormData(form)
    authAxios
      .post(`master/index/${idm}/${u}?page=${page}`, formData)
      .then((datosRespuesta) => {
        setNombre(datosRespuesta.data.tabla)
        var status = datosRespuesta.data.status
        setTabla(datosRespuesta.data.modelo)
        setLista(datosRespuesta.data.data.data)
        setTitulo(datosRespuesta.data.titulo)
        setTamano(datosRespuesta.data.formulario)
        setActual(datosRespuesta.data.data.current_page)
        setUltimo(datosRespuesta.data.data.last_page)
        setPagina(datosRespuesta.data.data.total)
        setTab(datosRespuesta.data.nav)
        setRegistrar(datosRespuesta.data.permisos.registrar)
        setEditar(datosRespuesta.data.permisos.editar)
        setEliminar(datosRespuesta.data.permisos.eliminar)
        setConsultar(datosRespuesta.data.permisos.consultar)
        setCargar(datosRespuesta.data.permisos.cargar)
        setBtnConfiguracion(datosRespuesta.data.permisos.configuracion)
        Swal.close()
      })
      .catch()
  }

  const ListaTablaExp = async (idm) => {
    const form = document.getElementById("buscador")
    const formData = new FormData(form)
    setBoton("Generando Listado..")
    authAxios
      .post(`master/exportar/${idm}`, formData)
      .then((datosRespuesta) => {
        Swal.close()
        var status = datosRespuesta.data.status
        setBoton(
          <button type="button" className="btn btn-info btn-sm" id="btndescargar">
            {" "}
            Descargar Listado
          </button>,
        )
        setListaExp(datosRespuesta.data.data)
        setTablaExp(datosRespuesta.data.modelo)
      })
      .catch()
  }

  const ListaVehiculos = async () => {
    authAxios
      .post(`control/vehiculos-activos`)
      .then((datosRespuesta) => {
        var datosRespuesta = datosRespuesta.data.vehiculos
        console.log(datosRespuesta)
        setVehiculos(datosRespuesta)
      })
      .catch()
  }

  const VerRegistros = async (idm, ide) => {
    Swal.showLoading()
    try {
      const response = await authAxios.get(`master/ver/${idm}/${ide}`)
      const datosRespuesta = response.data
      console.log("Datos recibidos:", datosRespuesta)

      if (datosRespuesta && datosRespuesta.result) {
        const lista = datosRespuesta.result
        console.log("Datos del FUEC:", lista)
        setDetalles(lista)
        setInactivarBoton(datosRespuesta.editar)
        setVerBoton(1)
        const campos = datosRespuesta.modelo
        Swal.close()

        if (idm == 14) {
          // Tu lógica específica para idm 14
        } else {
          campos.map((item, i) =>
            item.trae_tabla != null
              ? (document.getElementById(item.nombre_campo + "_name").value = lista[item.nombre_campo + "_name"] || "")
              : "",
          )
        }

        setElementosControl(datosRespuesta.data.elementos_control || [])

        campos.map(
          (item, i) => (
            item.tipo_dato == "blob"
              ? (document.getElementById("img" + item.nombre_campo).src =
                lista[item.nombre_campo] != null
                  ? apiImage + lista[item.nombre_campo]
                  : "https://nosso.com/public/images/tipoproducto/default.jpg")
              : "",
            item.tipo_dato !== "blob"
              ? (document.getElementById(item.nombre_campo).value = lista[item.nombre_campo] || "")
              : ""
          ),
        )

      } else {
        console.error("Estructura de datos inesperada:", datosRespuesta)
        Swal.fire("Error", "No se pudieron cargar los datos", "error")
      }
    } catch (error) {
      console.error("Error en VerRegistros:", error)
      Swal.close()
      Swal.fire("Error", "No se pudo cargar el registro", "error")
    }
  }

  const traerkmver = async (idm, ide) => {
    document.getElementById("kmactualver").value = ""
    document.getElementById("kmactualverinputid").value = ""
    document.getElementById("kmnuevoact").value = ""
    Swal.showLoading()
    authAxios
      .get(`master/ver/${idm}/${ide}`)
      .then((datosRespuesta) => {
        const lista = datosRespuesta.data.result
        const campos = datosRespuesta.data.modelo
        Swal.close()
        console.log(lista)
        document.getElementById("kmactualver").value = lista.odometro
        document.getElementById("kmactualverinputid").value = lista.id
      })
      .catch()
  }

  const actualizarkmvehiculo = async () => {
    Swal.showLoading()
    var kmvh = document.getElementById("kmnuevoact").value
    var id = document.getElementById("kmactualverinputid").value
    authAxios
      .get(`actualizarkmvehiculo/${id}/${kmvh}`)
      .then((datosRespuesta) => {
        Swal.close()
        document.getElementById("kmactualver").value = ""
        document.getElementById("kmactualverinputid").value = ""
        document.getElementById("kmnuevoact").value = ""
      })
      .catch()
  }

  const verProgramacionVh = async (id) => {
    setTablaProgramacion([])
    setTablaProgramacionEjecucion([])
    Swal.showLoading()
    console.log(id)
    authAxios
      .get(`consultar-programacion-mantenimiento/${id}`)
      .then((datosRespuesta) => {
        Swal.close()
        setTablaProgramacion(datosRespuesta.data.vehiculos)
        setTablaProgramacionEjecucion(datosRespuesta.data.ejecucion)
        console.log(TablaProgramacion)
      })
      .catch()
  }

  const cambioClaveUsuarioProveedor = async (idm, ide) => {
    Swal.showLoading()
    console.log("usuario" + ide)
    authAxios
      .get(`master/ver/${idm}/${ide}`)
      .then((datosRespuesta) => {
        Swal.close()
        setIdUsuario(ide)
      })
      .catch()
  }

  const guardarClaveProveedor = async (idm, ide) => {
    const form = document.getElementById("form_registro_password")
    const formData = new FormData(form)
    Swal.showLoading()
    console.log(IdUsuario)
    authAxios
      .post(`modulos/cambioclaveproveedor/${IdUsuario}`, formData)
      .then((datosRespuesta) => {
        Swal.close()
        Swal.fire("Con Exito!", "Cambio de clave exitoso", "success")
      })
      .catch()
  }

  const borrarRegistros = async (idm, id) => {
    const u = localStorage.getItem("idusuario")
    Swal.fire({
      title: "Está seguro de Eliminar el registro?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Borrar",
      denyButtonText: `Cancelar`,
    }).then((result) => {
      if (result.isConfirmed) {
        authAxios
          .get(`master/borrar/${idm}/${id}/${u}`)
          .then((datosRespuesta) => {
            Swal.fire("Borrado!", datosRespuesta.data.msj, "success")
            ListaTabla(idm, 1)
          })
          .catch()
      } else if (result.isDenied) {
        Swal.fire("Cancelado", "", "info")
      }
    })
  }

  const eliminarAsignacion = async (idm, id) => {
    const u = localStorage.getItem("idusuario")
    Swal.fire({
      title: "Está seguro de Eliminar la asigancion del servicio?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Borrar",
      denyButtonText: `Cancelar`,
    }).then((result) => {
      if (result.isConfirmed) {
        authAxios
          .get(`control/deleteservicio/${id}`)
          .then((datosRespuesta) => {
            Swal.fire("Borrado!", datosRespuesta.data.msj, "success")
            ListaTabla(idm, 1)
          })
          .catch()
      } else if (result.isDenied) {
        Swal.fire("Cancelado", "", "info")
      }
    })
  }

  const BorrarRelacion = async (tabla, fk, id) => {
    Swal.fire({
      title: "Está seguro de Eliminar el registro?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Borrar",
      denyButtonText: `Cancelar`,
    }).then((result) => {
      if (result.isConfirmed) {
        authAxios
          .get(`master/borrar_relacion/${tabla}/${id}`)
          .then((datosRespuesta) => {
            Swal.fire("Borrado!", datosRespuesta.data.msj, "success")
            VerDatos(tabla, fk, 1)
          })
          .catch()
      } else if (result.isDenied) {
        Swal.fire("Cancelado", "", "info")
      }
    })
  }

  const DescargarExcel = () => {
    Swal.showLoading()
    axios({
      url: Url + "exportar/listado/" + idmenu,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      const blob = new Blob([response.data], { type: "application/vnd.ms-excel" })
      saveAs(blob, "plantila" + idmenu + ".xlsx")
      Swal.close()
    })
  }

  const actualizarRelaciones = (tablaforanea, relacion_fk) => {
    VerDatos(tablaforanea, relacion_fk, 1)
  }

  const save = async () => {
    Swal.showLoading()
    const form = document.getElementById("form_registro")
    const formData = new FormData(form)
    const u = localStorage.getItem("idusuario")
    authAxios
      .post(`master/registrar/${idmenu}/${u}`, formData)
      .then((datosRespuesta) => {
        var status = datosRespuesta.data.status
        if (datosRespuesta.data.Status) {
          Swal.fire("Registro!", datosRespuesta.data.msj, "success")
          document.getElementById("form_registro").reset()
          $("#id").val("")
          setVerBoton(0)
          ListaTabla(`${idmenu}`, 1)
        } else {
          Swal.close()
          Swal.fire("Registro!", datosRespuesta.data.msj, "error")
        }
      })
      .catch()
  }

  const handleAdditionalFormTimeChange = (index, time) => {
    const localTime = new Date(time)
    const hours = localTime.getHours().toString().padStart(2, "0")
    const minutes = localTime.getMinutes().toString().padStart(2, "0")
    const formattedTime = `${hours}:${minutes}`

    const newAdditionalFormsData = [...additionalFormsData]
    newAdditionalFormsData[index] = {
      ...newAdditionalFormsData[index],
      horaInicial: formattedTime,
    }
    setAdditionalFormsData(newAdditionalFormsData)
  }

  const enviarFactura = async (id) => {
    Swal.showLoading()
    console.log(id)
    const u = localStorage.getItem("idusuario")
    authAxios
      .post(`exterior/crear-factura-siggo/${id}/${u}`)
      .then((datosRespuesta) => {
        var status = datosRespuesta.data.status
        Swal.fire("Registro!", datosRespuesta.data.msj, "success")
        document.getElementById("form_registro").reset()
        $("#id").val("")
        setVerBoton(0)
        ListaTabla(`${idmenu}`, 1)
      })
      .catch()
  }

  const saveProgramacion = async () => {
    Swal.showLoading()
    const form = document.getElementById("form_registro")
    const formData = new FormData(form)
    const u = localStorage.getItem("idusuario")
    authAxios
      .post(`programacion-mantenimiento/${u}`, formData)
      .then((datosRespuesta) => {
        var status = datosRespuesta.data.status
        if (datosRespuesta.data) {
          Swal.fire("Registro!", datosRespuesta.data.msj, "success")
          document.getElementById("form_registro").reset()
          $("#id").val("")
          setVerBoton(0)
          ListaTabla(`${idmenu}`, 1)
        } else {
          Swal.close()
          Swal.fire("Registro!", datosRespuesta.data.msj, "error")
        }
      })
      .catch()
  }

  const importar = async () => {
    const excel = document.getElementById("excel").value
    if (excel == "") {
      Swal.fire("Registro!", "Debes de subir un docuemnto", "error")
      return false
    }
    Swal.showLoading()
    const form = document.getElementById("subir")
    const formData = new FormData(form)
    authAxios
      .post(`master/importar/${idmenu}`, formData)
      .then((datosRespuesta) => {
        var status = datosRespuesta.data.status
        if (datosRespuesta.data.Status) {
          Swal.fire("Registro!", datosRespuesta.data.msj, "success")
          setVerBoton(0)
          ListaTabla(`${idmenu}`, 1)
        } else {
          Swal.close()
          Swal.fire("Registro!", datosRespuesta.data.msj, "error")
        }
        document.getElementById("subir").reset()
      })
      .catch()
  }

  const limpiarformulario = () => {
    document.getElementById("form_registro").reset()
    setVerBoton(0)
  }

  const VerRelaciones = (idmenu, iditem) => {
    document.getElementById("item").value = iditem
    setRelTabla([])
    setRelLista([])
    setIsLoading(true)
    authAxios
      .get("modulos/listarelaciones/" + NombreTabla)
      .then((datosRespuesta) => {
        var status = datosRespuesta.data.status
        setRelaciones(datosRespuesta.data.tabla)
        setIsLoading(false)
      })
      .catch()
  }

  const Verimagen = (url) => {
    if (typeof url !== "string" || url.trim() === "") return

    window.open(apiImage + url.replace(/^\/+/, ""), "sharer", "toolbar=0,status=0,width=548,height=325")
  }

  const VerimagenImp = (campo) => {
    const input = document.getElementById("temp" + campo)
    const c = input?.value

    if (typeof c === "string" && c.trim() !== "") {
      window.open(apiImage + c.replace(/^\/+/, ""), "sharer", "toolbar=0,status=0,width=548,height=325")
    }
  }

  const savecaracol = () => {
    const form = document.getElementById("form_registro")
    const formData = new FormData(form)
    const u = localStorage.getItem("idusuario")
    formData.append("idusuario", u)
    Swal.showLoading()
    authAxios
      .post("transporte/vehiculo", formData)
      .then((response) => {
        Swal.close()
        if (response.data[0].Confirmacion) {
          Swal.fire({
            title: "Vehiculo Agregado a caracol con exito",
            icon: "success",
          })
        } else {
          const errorMessages = response.data[0].ListaMensajes.map((mensaje) => mensaje.Descripcion)
          if (errorMessages.length > 1) {
            const tableContent = errorMessages
              .map((mensaje, index) => `<tr key=${index}><td>${index + 1}</td><td>${mensaje}</td></tr>`)
              .join("")
            const tableHTML = `
              <div>
                <table className="table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Error</th>
                    </tr>
                  </thead>
                  <tbody>${tableContent}</tbody>
                </table>
              </div>
            `
            Swal.fire({
              title: "Se encontraron los siguientes errores:",
              html: tableHTML,
              icon: "error",
            })
          } else {
            Swal.fire("Conductores", errorMessages[0], "error")
          }
        }
      })
      .catch()
  }

  const savecaracolconductores = () => {
    const form = document.getElementById("form_registro")
    const formData = new FormData(form)
    const u = localStorage.getItem("idusuario")
    formData.append("idusuario", u)
    Swal.showLoading()
    authAxios
      .post("transporte/conductor", formData)
      .then((response) => {
        Swal.close()
        if (response.data.Status) {
          if (response.data.resultado_caracol[0].Confirmacion) {
            ListaTabla(`${idmenu}`, 1)
            Swal.fire({
              title: "Conductor Agregado a caracol con exito",
              icon: "success",
            })
          } else {
            const errorMessages = response.data.resultado_caracol[0].ListaMensajes.map((mensaje) => mensaje.Descripcion)
            if (errorMessages.length > 1) {
              const tableContent = errorMessages
                .map((mensaje, index) => `<tr key=${index}><td>${index + 1}</td><td>${mensaje}</td></tr>`)
                .join("")
              const tableHTML = `
                <div>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Error</th>
                      </tr>
                    </thead>
                    <tbody>${tableContent}</tbody>
                  </table>
                </div>
              `
              Swal.fire({
                title: "Se encontraron los siguientes errores:",
                html: tableHTML,
                icon: "error",
              })
            } else {
              Swal.fire("Conductores", errorMessages[0], "error")
            }
          }
        } else {
          Swal.close()
          Swal.fire("Registro!", response.data.msj, "error")
        }
      })
      .catch()
  }

  const VerDatos = (tabla, id, pag) => {
    setForanea(tabla)
    setLlave(id)
    setIsLoadingTable(true)
    var item = document.getElementById("item").value
    setRelacionId(item)
    authAxios
      .get("master/verrelacion/" + tabla + "/" + id + "/" + item + "?page=" + pag)
      .then((datosRespuesta) => {
        var status = datosRespuesta.data.status
        setIsLoadingTable(false)
        setRelTabla(datosRespuesta.data.modelo)
        setRelLista(datosRespuesta.data.data.data)
        setRelActual(datosRespuesta.data.data.current_page)
        setRelUltimo(datosRespuesta.data.data.last_page)
        setRelTab(datosRespuesta.data.tabla)
        setPestana(datosRespuesta.data.nav)
        setMenu(datosRespuesta.data.modelo[0].id_menu)
        setValor(datosRespuesta.data.traevalue)
      })
      .catch()
  }

  const CambiarPermiso = (id, campo) => {
    var che = document.getElementById(campo + id)
    var valor = "No"
    if (che.checked == true) {
      valor = "Si"
    }
    Swal.showLoading()
    authAxios
      .get("modulos/registrarcampoitem/" + id + "/" + campo + "/" + valor)
      .then((datosRespuesta) => {
        Swal.close()
        var status = datosRespuesta.data.status
        Tablas(idmenu)
      })
      .catch()
  }

  const verfactura = (id) => {
    window.localStorage.setItem("Factura", id)
  }

  const CambiarNombre = (id, campo) => {
    var valor = document.getElementById(campo + id).value
    if (valor == "") {
      valor = 0
    }
    authAxios
      .get("modulos/registrarcampoitem/" + id + "/" + campo + "/" + valor)
      .then((datosRespuesta) => {
        Swal.close()
        var status = datosRespuesta.data.status
        Tablas(idmenu)
      })
      .catch()
  }

  const Tablas = (id_menu) => {
    authAxios
      .get("modulos/tablas/" + id_menu)
      .then((datosRespuesta) => {
        var status = datosRespuesta.data.status
        setConfiguracion(datosRespuesta.data)
      })
      .catch()
  }

  const MostrarSelect = async (tabla, id, nombre) => {
    var da = { tabla, id, nombre, NombreTabla }
    authAxios
      .post("master/relacion", da)
      .then((datosRespuesta) => {
        var status = datosRespuesta.data.status
      })
      .catch()
  }

  // FUNCIÓN BUSCAR MODIFICADA PARA ACEPTAR FILTRO POR CLIENTE
  const Buscar = async (tabla, id, nombre, campo, fk, campo_modalidad = null) => {
    setSearchTerm1("")
    setIsLoadingOpen(true)
    console.log(tabla, id, nombre, campo)
    setTablaModal([])
    setInput(campo + "_name")
    setInputId(campo)
    setInputTabla(tabla)
    setInputTablaId(id)
    setCampoSeleccionado(nombre)
    setCampoFk(fk)

    let valorfk = '';
    if (fk && fk !== '') {
      valorfk = document.getElementById(fk).value;
    }

    let modalidad_id = '';
    if (campo_modalidad && campo_modalidad !== '') {
      modalidad_id = document.getElementById(campo_modalidad)?.value || '';
    }

    var da = { tabla, id, nombre, fk, valorfk, modalidad_id }
    authAxios
      .post("master/relacion_fk", da)
      .then((datosRespuesta) => {
        var status = datosRespuesta.data.status
        setTablaModal(datosRespuesta.data)
        setIsLoadingOpen(false)
      })
      .catch()
  }

  const buscarExpediente = async () => {
    setIsLoadingOpen(true)
    Swal.showLoading()
    authAxios
      .post("master/relacion/buscar-expediente")
      .then((datosRespuesta) => {
        Swal.close()
        var status = datosRespuesta.data.status
        console.log(datosRespuesta.data.prefijo)
        const numeroExpediente = (document.getElementsByName("numeroExpediente")[0].value =
          datosRespuesta.data.prefijo + datosRespuesta.data.consecutivo)
        setFormValues((prevValues) => ({
          ...prevValues,
          numeroExpediente: datosRespuesta.data.prefijo + datosRespuesta.data.consecutivo,
        }))
        setIsLoadingOpen(false)
      })
      .catch()
  }

  const BuscarIdentificacion = async (tabla, id, nombre, campo) => {
    setIsLoadingOpen(true)
    console.log(tabla, id, nombre, campo)
    setTablaModal([])
    setInput(campo + "_name")
    setInputId(campo)
    setInputTabla(tabla)
    setInputTablaId(id)
    setCampoSeleccionado(nombre)
    var identificacion = document.getElementById("identificacion_usuario_name").value
    var da = { tabla, id, nombre, identificacion: identificacion }
    authAxios
      .post("master/buscar-cliente", da)
      .then((datosRespuesta) => {
        var status = datosRespuesta.data.status
        var data = datosRespuesta.data.data
        setFormValues({
          ...formValues,
          nombreUsuario: data.nombre,
          apellidoUsuario: data.apellido,
          correoUsuario: data.correo,
          direccionUsuario: data.direccion,
          telefonoUsuario: data.telefono,
        })
        document.getElementsByName("nombreUsuario")[0].value = data.nombre
        document.getElementsByName("apellidoUsuario")[0].value = data.apellido
        document.getElementsByName("correoUsuario")[0].value = data.correo
        document.getElementsByName("direccionUsuario")[0].value = data.direccion
        document.getElementsByName("telefonoUsuario")[0].value = data.telefono
      })
      .catch()
  }

  // FUNCIÓN SELECCIONAR MODIFICADA
  const Seleccionar = async (id, nombre, tabla) => {
    // Si es el campo cliente, usar el manejador especial
    if (tabla === "clientes") {
      await handleClienteChange(id, nombre, tabla);
      return;
    }

    console.log("campos seleccionados: " + id, nombre, tabla, IdCampo);

    setFormValues((prevValues) => {
      let updatedItems = [...prevValues.items];
      if (Array.isArray(id)) {
        updatedItems = [...updatedItems, ...id];
      } else {
        updatedItems.push(id);
      }
      return {
        ...prevValues,
        [tabla]: updatedItems,
        time: "",
      };
    });

    if (tabla == "categoria_vehiculo") {
      var campos = "";
      if (nombre == "PRIMEROS" || nombre == "SEGUNDOS") {
        campos = ".propio-si.hidden";
      } else {
        campos = ".contratista-si.hidden";
      }
      const formElement = document.getElementById("form_registro");
      const divs = formElement.querySelectorAll(campos);
      divs.forEach((div) => {
        console.log(div);
        div.classList.remove("hidden");
      });
    }

    if (tabla == "modalidad_tari") {
      if (id == 5) {
        setIsCantidadHorasDisabled(false);
      } else {
        setIsCantidadHorasDisabled(true);
      }
    }

    console.log(Campo);
    if (tabla == "tip_vehiculo" || tabla == "modalidad_tari" || tabla == "producciones") {
      const nuevaSeleccion = [
        ...(infoSeleccionada ?? []).filter(item => item.tabla !== tabla),
        { nombre, id, tabla }
      ];
      setInfoSeleccionada(nuevaSeleccion);
      const payload = {
        infoSeleccionada: nuevaSeleccion,
        nombre,
        id,
        tabla
      };
      console.log("Payload a enviar:", payload);
      authAxios
        .post("master/relacion/tarifa", payload)
        .then((datosRespuesta) => {
          const { data } = datosRespuesta.data;
          setFormValues({
            ...formValues,
            tarifasDisponibles: data,
            tarifa: ""
          });
        })
        .catch((error) => {
          console.error("Error al obtener las tarifas:", error);
        });
    }

    document.getElementById(Campo).value = nombre;
    document.getElementById(IdCampo).value = id;
  }

  const AddExtra = () => {
    var extra = document.getElementById("extra").value
    var da = { tabla: InputTabla, nombre: extra, campo: CampoSeleccionado }
    authAxios
      .post("master/addextra", da)
      .then((datosRespuesta) => {
        var status = datosRespuesta.data.status
        var es = datosRespuesta.data.estado
        Swal.fire("Registro!", datosRespuesta.data.msj, es == 1 ? "success" : "danger")
        Buscar(InputTabla, InputTablaId, CampoSeleccionado, IdCampo, CampoFk)
      })
      .catch()
  }

  const agregaropc = (campo, id, value) => {
    setVistaCampo(campo)
    MostrarSelect(campo, id, value)
    var rel = (document.getElementById("vista_relacion").value = campo)
  }

  const AddRelacion = () => {
    var rel = document.getElementById("vista_relacion").value
    var id = document.getElementById("vista_id_relacion").value
    if (rel == "") {
      Swal.fire("", "Debes de seleccionar el campo a relacionar", "warning")
      return false
    }
    if (id == "") {
      Swal.fire("", "Debes de llenar el campo id relacion", "warning")
      return false
    }
    var da = { tabla: NombreTabla, id: id, campo: rel }
    authAxios
      .post("master/addvista", da)
      .then((datosRespuesta) => {
        var status = datosRespuesta.data.status
        var es = datosRespuesta.data.estado
        Swal.fire("Registro!", datosRespuesta.data.Msj, es == 1 ? "success" : "warning")
        MostrarRelacionVista()
      })
      .catch()
  }

  const MostrarRelacionVista = () => {
    var da = { tabla: NombreTabla }
    authAxios
      .post("master/mostrarvista", da)
      .then((datosRespuesta) => {
        var status = datosRespuesta.data.status
      })
      .catch()
  }

  const MostrarSeleccionados = (id) => {
    var da = { tabla: NombreTabla, id }
    authAxios
      .post("master/mostrarvistaitem", da)
      .then((datosRespuesta) => {
        var status = datosRespuesta.data.status
      })
      .catch()
  }

  const RelacionItem = (id) => {
    setRelacionItems(id)
    MostrarSeleccionados(id)
  }

  const AddVistItem = (id) => {
    var da = { tabla: NombreTabla, id: id, VistaCampo: VistaCampo, RelacionItems: RelacionItems }
    authAxios
      .post("master/addvistaitem", da)
      .then((datosRespuesta) => {
        var status = datosRespuesta.data.status
      })
      .catch()
  }

  const manejoNuevoRegistro = (id) => {
    limpiarformulario()
    if (id == 6) {
      const formElement = document.getElementById("form_registro")
      const divs = formElement.querySelectorAll(
        "div.col-md-4.text-left, div.col-md-6.text-left, div.col-md-8.text-left,div.col-md-12.text-left",
      )
      divs.forEach((div) => {
        const elementId = div.getAttribute("id")
        if (elementId !== "categoria_vehiculos-div") {
          div.classList.add("hidden")
        } else {
          div.classList.remove("hidden")
        }
      })
    }
  }

  // LISTENER PARA OBSERVAR CAMBIOS EN EL CAMPO CLIENTE
  React.useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
          const clienteInput = document.getElementById("nombre_clientes");
          const produccionInput = document.getElementById("produccion");

          if (clienteInput && produccionInput) {
            const oldValue = mutation.oldValue;
            const newValue = clienteInput.value;

            if (oldValue !== newValue && produccionInput.value) {
              produccionInput.value = "";
              const produccionNameInput = document.getElementById("produccion_name");
              if (produccionNameInput) {
                produccionNameInput.value = "";
              }

              setFormValues(prev => ({
                ...prev,
                produccion: "",
                tarifasDisponibles: [],
                tarifa: "",
                tarifa_base: "",
                costo_tercero: "",
                valorServicio: ""
              }));

              Swal.fire({
                icon: "info",
                title: "Producción reiniciada",
                text: "Se ha reiniciado la producción porque cambiaste el cliente",
                timer: 2000,
                timerProgressBar: true,
                showConfirmButton: false
              });
            }
          }
        }
      });
    });

    const clienteInput = document.getElementById("nombre_clientes");
    if (clienteInput) {
      observer.observe(clienteInput, {
        attributes: true,
        attributeOldValue: true,
        attributeFilter: ['value']
      });
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div>
      <div className="content">
        <div className="content-wrapper">
          <div className="content">
            <div className="container-fluid">
              <br />
              <div className="card">
                <div className="card-body">
                  <h4>
                    Lista Servicios En tiempo Real
                    <div className="text-end">
                      {Registrar == 1 ? (
                        <button
                          type="button"
                          className="btn btn-success"
                          style={{ marginRight: 10 }}
                          data-bs-toggle="modal"
                          data-bs-target="#FormularioModal"
                          onClick={() => manejoNuevoRegistro(`${idmenu}`)}
                        >
                          <FontAwesomeIcon icon={faPlus} /> Nuevo Registro
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                    <input type="hidden" className="form-control" id="tabla" name="tabla" value={NombreTabla} />
                  </h4>
                  <div className="row table-responsive">
                    <form id="buscador">

                    </form>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="FormularioModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-labelledby="nuevoPacienteSubLabel"
        aria-hidden="true"
      >
        <div className={"modal-dialog  modal-xl"} role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="permisoRolesModalLabel">
                Formulario de registro {Titulo}
              </h4>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <form id="form_registro">
                <div className="card-body">
                  <ul className="nav nav-tabs" id="icon-tab" role="tablist">
                    {Tabs.map((row, i) => (
                      <li key={i} className="nav-item">
                        <a
                          className={i == 0 ? "nav-link active" : "nav-link"}
                          id="icon-home-tab"
                          data-bs-toggle="tab"
                          href={"#icon-" + row.pestana}
                          role="tab"
                          aria-controls={"icon-" + row.pestana}
                          aria-selected="true"
                        >
                          <i className={i == 0 ? "icofont icofont-ui-home" : "icofont icofont-files"}></i>
                          {row.pestana == null ? "DATOS_BASICOS" : row.pestana}
                        </a>
                      </li>
                    ))}
                    {Titulo == "Vehiculos" ? (
                      <>
                        <li className="nav-item">
                          <a
                            className={"nav-link"}
                            id="icon-home-tab"
                            data-bs-toggle="tab"
                            href={"#icon-programacion"}
                            role="tab"
                            aria-controls={"icon-programacion"}
                            aria-selected="true"
                            onClick={() => verProgramacionVh(Detalles.id)}
                          >
                            <i className={"icofont"}></i>MANTENIMIENTOS
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className={"nav-link"}
                            id="icon-home-tab"
                            data-bs-toggle="tab"
                            href={"#icon-ejecucion-registrar"}
                            role="tab"
                            aria-controls={"icon-ejecucion-registrar"}
                            aria-selected="true"
                          >
                            <i className={"icofont"}></i>REGISTRAR EJECUCION
                          </a>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                  </ul>

                  <div className="tab-content" id="icon-tabContent" key={1}>
                    {Tabs.map((fila, i) => (
                      <>
                        <div
                          className={i == 0 ? "tab-pane fade show active" : "tab-pane fade"}
                          id={"icon-" + fila.pestana}
                          role="tabpanel"
                          aria-labelledby={"icon-" + fila.pestana + "-tab"}
                        >
                          <div className="card-body">
                            <div className="row">
                              <div className="card" key={fila.id}>
                                <div className="row card-body">
                                  {NombreTabla == "mantenimientos" ? (
                                    <div>
                                      <label htmlFor="">
                                        Todos los vehículos:
                                        <input
                                          type="checkbox"
                                          name="todos"
                                          checked={selectAll}
                                          onChange={handleSelectAll}
                                        />
                                      </label>
                                      <br />
                                      <input
                                        type="text"
                                        placeholder="Buscar Vehículos"
                                        className="form-control mb-3"
                                        value={searchTerm}
                                        onChange={handleSearch}
                                      />
                                      {filteredVehiculos.map((vh) => (
                                        <div className="form-check form-check-inline" key={vh.placa}>
                                          <input
                                            className="form-check-input"
                                            name="vehiculo_placa[]"
                                            type="checkbox"
                                            id={vh.placa}
                                            value={vh.id}
                                            checked={selectAll}
                                          />
                                          <label className="form-check-label" htmlFor={vh.placa}>
                                            {vh.placa}
                                          </label>
                                        </div>
                                      ))}
                                    </div>
                                  ) : (
                                    ""
                                  )}

                                  {NombreTabla == "servicio" ? (
                                    <>
                                      <div className="row p-4">
                                      <fieldset className="border p-3 mb-3 w-100 border-secondary" style={{ borderRadius: '5px' }}>
                                        <legend className="w-auto px-2" style={{ fontSize: '1rem', fontWeight: 'bold', color: '#2c3e50' }}>DATOS BASICOS</legend>
                                        <div className="row g-2">
                                          <div className="col-md-6">
                                                                                  <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Cliente</label>
                                                                                  <>
                                                                                    <input
                                                                                      onInput={(e) => {
                                                                                        e.target.value = e.target.value.toUpperCase()
                                                                                      }}
                                                                                      className={"form-control form-control-sm"}
                                                                                      readOnly={"readOnly"}
                                                                                      type={"hidden"}
                                                                                      name={"nombre_clientes"}
                                                                                      onChange={handleInputChange}
                                                                                      id={"nombre_clientes"}
                                                                                    />
                                                                                    <div className="input-group mb-3">
                                                                                      <input
                                                                                        onInput={(e) => {
                                                                                          e.target.value = e.target.value.toUpperCase()
                                                                                        }}
                                                                                        className={"form-control form-control-sm"}
                                                                                        readOnly={"readOnly"}
                                                                                        type={"text"}
                                                                                        name={"nombre_clientes" + "_name"}
                                                                                        onChange={handleInputChange}
                                                                                        id={"nombre_clientes" + "_name"}
                                                                                      />
                                                                                      <button
                                                                                        className="btn btn-outline-secondary btn-sm"
                                                                                        onClick={() => Buscar("clientes", "id", "nombres", "nombre_clientes", "")}
                                                                                        type="button"
                                                                                        data-bs-toggle="modal"
                                                                                        data-bs-target="#ModalSelect"
                                                                                      >
                                                                                        <FontAwesomeIcon icon={faSearch} />
                                                                                      </button>
                                                                                    </div>
                                                                                  </>
                                                                                </div>
                                          <div className="col-md-3">
                                                                                  <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Produccion</label>
                                                                                  <input
                                                                                    onInput={(e) => {
                                                                                      e.target.value = e.target.value.toUpperCase()
                                                                                    }}
                                                                                    className={"form-control form-control-sm"}
                                                                                    readOnly={"readOnly"}
                                                                                    onChange={handleInputChange}
                                                                                    type={"hidden"}
                                                                                    name={"produccion"}
                                                                                    id={"produccion"}
                                                                                  />
                                                                                  <div className="input-group mb-3">
                                                                                    <input
                                                                                      onInput={(e) => {
                                                                                        e.target.value = e.target.value.toUpperCase()
                                                                                      }}
                                                                                      className={"form-control form-control-sm"}
                                                                                      readOnly={"readOnly"}
                                                                                      onChange={handleInputChange}
                                                                                      type={"text"}
                                                                                      name={"produccion" + "_name"}
                                                                                      id={"produccion" + "_name"}
                                                                                    />
                                                                                    <button
                                                                                      className="btn btn-outline-secondary btn-sm"
                                                                                      onClick={() => {
                                                                                        const clienteId = document.getElementById("nombre_clientes")?.value;
                                                                                        if (!clienteId) {
                                                                                          Swal.fire({
                                                                                            icon: "warning",
                                                                                            title: "Cliente no seleccionado",
                                                                                            text: "Primero debes seleccionar un cliente",
                                                                                            timer: 3000,
                                                                                            timerProgressBar: true
                                                                                          });
                                                                                          return;
                                                                                        }
                                                                                        Buscar("producciones", "id", "nombre_produccion", "produccion", "nombre_clientes");
                                                                                      }}
                                                                                      type="button"
                                                                                      data-bs-toggle="modal"
                                                                                      data-bs-target="#ModalSelect"
                                                                                    >
                                                                                      <FontAwesomeIcon icon={faSearch} />
                                                                                    </button>
                                                                                  </div>
                                                                                </div>
                                          <div className="col-md-3">
                                                                                  <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Modalidad Servicio</label>
                                                                                  <>
                                                                                    <input
                                                                                      onInput={(e) => {
                                                                                        e.target.value = e.target.value.toUpperCase()
                                                                                      }}
                                                                                      className={"form-control form-control-sm"}
                                                                                      readOnly={"readOnly"}
                                                                                      onChange={handleInputChange}
                                                                                      type={"hidden"}
                                                                                      name={"modalidad_nombre"}
                                                                                      id={"modalidad_nombre"}
                                                                                    />
                                                                                    <div className="input-group mb-3">
                                                                                      <input
                                                                                        onInput={(e) => {
                                                                                          e.target.value = e.target.value.toUpperCase()
                                                                                        }}
                                                                                        className={"form-control form-control-sm"}
                                                                                        readOnly={"readOnly"}
                                                                                        onChange={handleInputChange}
                                                                                        type={"text"}
                                                                                        name={"modalidad_nombre" + "_name"}
                                                                                        id={"modalidad_nombre" + "_name"}
                                                                                      />
                                                                                      <button
                                                                                        className="btn btn-outline-secondary btn-sm"
                                                                                        onClick={() =>
                                                                                          Buscar("modalidad_tari", "id", "nombre", "modalidad_nombre", "nombre_clientes")
                                                                                        }
                                                                                        type="button"
                                                                                        data-bs-toggle="modal"
                                                                                        data-bs-target="#ModalSelect"
                                                                                      >
                                                                                        <FontAwesomeIcon icon={faSearch} />
                                                                                      </button>
                                                                                    </div>
                                                                                  </>
                                                                                </div>
                                          <div className="col-md-4">
                                            <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Disponibilidad</label>
                                            <>
                                              <input
                                                onInput={(e) => {
                                                  e.target.value = e.target.value.toUpperCase()
                                                }}
                                                className={"form-control form-control-sm"}
                                                readOnly={"readOnly"}
                                                onChange={handleInputChange}
                                                type={"hidden"}
                                                name={"cantidad_modalidad"}
                                                id={"cantidad_modalidad"}
                                              />
                                              <div className="input-group mb-3">
                                                <input
                                                  onInput={(e) => {
                                                    e.target.value = e.target.value.toUpperCase()
                                                  }}
                                                  className={"form-control form-control-sm"}
                                                  readOnly={"readOnly"}
                                                  onChange={handleInputChange}
                                                  type={"text"}
                                                  name={"cantidad_modalidad" + "_name"}
                                                  id={"cantidad_modalidad" + "_name"}
                                                />
                                                <button
                                                  className="btn btn-outline-secondary btn-sm"
                                                  onClick={() =>
                                                    Buscar("disponibilidad_tari", "id", "nombre", "cantidad_modalidad", "nombre_clientes", "modalidad_nombre")
                                                  }
                                                  type="button"
                                                  data-bs-toggle="modal"
                                                  data-bs-target="#ModalSelect"
                                                >
                                                  <FontAwesomeIcon icon={faSearch} />
                                                </button>
                                              </div>
                                            </>
                                          </div>
                                          <div className="col-md-4">
                                                                                  <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Cantidad Horas</label>
                                                                                  <input
                                                                                    className={"form-control form-control-sm"}
                                                                                    type={"number"}
                                                                                    min={0}
                                                                                    name={"cantidad_horas"}
                                                                                    value={formValues.cantidad_horas}
                                                                                    onChange={handleInputChange}
                                                                                    disabled={isCantidadHorasDisabled}
                                                                                  />
                                                                                </div>
                                          <div className="col-md-4">
                                                                                  <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Tipo Vehiculo</label>
                                                                                  <>
                                                                                    <input
                                                                                      onInput={(e) => {
                                                                                        e.target.value = e.target.value.toUpperCase()
                                                                                      }}
                                                                                      className={"form-control form-control-sm"}
                                                                                      readOnly={"readOnly"}
                                                                                      onChange={handleInputChange}
                                                                                      type={"hidden"}
                                                                                      name={"tip_vehiculo"}
                                                                                      id={"tip_vehiculo"}
                                                                                    />
                                                                                    <div className="input-group mb-3">
                                                                                      <input
                                                                                        onInput={(e) => {
                                                                                          e.target.value = e.target.value.toUpperCase()
                                                                                        }}
                                                                                        className={"form-control form-control-sm"}
                                                                                        readOnly={"readOnly"}
                                                                                        onChange={handleInputChange}
                                                                                        type={"text"}
                                                                                        name={"tip_vehiculo" + "_name"}
                                                                                        id={"tip_vehiculo" + "_name"}
                                                                                      />
                                                                                      <button
                                                                                        className="btn btn-outline-secondary btn-sm"
                                                                                        onClick={() => Buscar("tip_vehiculo", "id", "nombre", "tip_vehiculo", "nombre_clientes")}
                                                                                        type="button"
                                                                                        data-bs-toggle="modal"
                                                                                        data-bs-target="#ModalSelect"
                                                                                      >
                                                                                        <FontAwesomeIcon icon={faSearch} />
                                                                                      </button>
                                                                                    </div>
                                                                                  </>
                                                                                </div>
                                        </div>
                                      </fieldset>
                                      <fieldset className="border p-3 mb-3 w-100 border-secondary" style={{ borderRadius: '5px' }}>
                                        <legend className="w-auto px-2" style={{ fontSize: '1rem', fontWeight: 'bold', color: '#2c3e50' }}>DATOS TARIFAS</legend>
                                        <div className="row g-2">
                                          {/* CAMPOS OCULTOS PARA GUARDAR VALORES DE LA TARIFA */}
                                          <input type="hidden" name="tarifa_base" value={formValues.tarifa_base || ''} />
                                          <input type="hidden" name="utilidad" value={formValues.valorServicio && formValues.costo_tercero ? (parseFloat(formValues.valorServicio) - parseFloat(formValues.costo_tercero)) : ''} />
                                          <input type="hidden" name="porcentaje_utilidad" value={formValues.valorServicio && formValues.costo_tercero ? ((parseFloat(formValues.valorServicio) - parseFloat(formValues.costo_tercero)) / parseFloat(formValues.valorServicio) * 100).toFixed(2) : ''} />
                                          
                                          <div className="col-md-4">
                                            <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Tarifa Sugerida</label>
                                            <div className="input-group input-group-sm">
                                                <input
                                                    type="hidden"
                                                    name="tarifa"
                                                    value={formValues.tarifa || ''}
                                                />
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    readOnly
                                                    value={formValues.tarifa ? `Tarifa #${formValues.tarifa}` : ''}
                                                    placeholder="Seleccione Tarifa"
                                                />
                                                <button
                                                    className="btn btn-outline-secondary"
                                                    type="button"
                                                    onClick={abrirModalTarifas}
                                                >
                                                    <FontAwesomeIcon icon={faSearch} />
                                                </button>
                                            </div>
                                          </div>
                                          <div className="col-md-4">
                                            <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Valor Servicio</label>
                                            <input
                                              className={"form-control form-control-sm"}
                                              type={"text"}
                                              name={"valorServicio"}
                                              value={formValues.valorServicio}
                                              onChange={handleInputChange}
                                              onBlur={handleValorServicioBlur}
                                            />
                                           
                                          </div>
                                          <div className="col-md-4">
                                            <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Costo Tercero</label>
                                            <input
                                              className={"form-control form-control-sm"}
                                              type={"number"}
                                              name={"costo_tercero"}
                                              id={"costo_tercero"}
                                              value={formValues.costo_tercero || ''}
                                              onChange={handleInputChange}
                                            />
                                             {formValues.tarifa && formValues.valorServicio && formValues.costo_tercero && (
                                              <div className="mt-1">
                                                {(() => {
                                                  const utilidad = parseFloat(formValues.valorServicio) - parseFloat(formValues.costo_tercero);
                                                  const porcentaje = (utilidad / parseFloat(formValues.valorServicio) * 100).toFixed(1);
                                                  const color = porcentaje < 15 ? 'text-danger' : porcentaje < 20 ? 'text-warning' : 'text-success';
                                                  
                                                  return (
                                                    <small className={color}>
                                                      Utilidad: ${utilidad.toFixed(0)} ({porcentaje}%)
                                                      {porcentaje < 15 && ' Por debajo del minimo'}
                                                    </small>
                                                  );
                                                })()}
                                              </div>
                                            )}
                                          </div>

                                          

                                          <div className="col-md-12 mt-2">
                                            <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Observaciones Internas</label>
                                            <textarea
                                              className={"form-control form-control-sm"}
                                              name={"obs_int"}
                                              value={formValues.obs_int}
                                              onChange={handleInputChange}
                                            ></textarea>
                                          </div>
                                        </div>
                                      </fieldset>
                                      <fieldset className="border p-3 mb-3 w-100 border-secondary" style={{ borderRadius: '5px' }}>
                                        <legend className="w-auto px-2" style={{ fontSize: '1rem', fontWeight: 'bold', color: '#2c3e50' }}>DATOS SERVICIO</legend>
                                        <div className="row g-2">
                                          <div className="col-md-3">
                                                                                  <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Ciudad</label>
                                                                                  <>
                                                                                    <input
                                                                                      onInput={(e) => {
                                                                                        e.target.value = e.target.value.toUpperCase()
                                                                                      }}
                                                                                      className={"form-control form-control-sm"}
                                                                                      readOnly={"readOnly"}
                                                                                      type={"hidden"}
                                                                                      onChange={handleInputChange}
                                                                                      name={"ciudad_nombre"}
                                                                                      id={"ciudad_nombre"}
                                                                                    />
                                                                                    <div className="input-group mb-3">
                                                                                      <input
                                                                                        onInput={(e) => {
                                                                                          e.target.value = e.target.value.toUpperCase()
                                                                                        }}
                                                                                        className={"form-control form-control-sm"}
                                                                                        readOnly={"readOnly"}
                                                                                        type={"text"}
                                                                                        onChange={handleInputChange}
                                                                                        name={"ciudad_nombre" + "_name"}
                                                                                        id={"ciudad_nombre" + "_name"}
                                                                                      />
                                                                                      <button
                                                                                        className="btn btn-outline-secondary btn-sm"
                                                                                        onClick={() => Buscar("ciudad", "id", "nombre", "ciudad_nombre", "")}
                                                                                        type="button"
                                                                                        data-bs-toggle="modal"
                                                                                        data-bs-target="#ModalSelect"
                                                                                      >
                                                                                        <FontAwesomeIcon icon={faSearch} />
                                                                                      </button>
                                                                                    </div>
                                                                                  </>
                                                                                </div>
                                          <div className="col-md-3">
                                                                                  <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Fecha</label>
                                                                                  <input
                                                                                    className={"form-control form-control-sm"}
                                                                                    type={"date"}
                                                                                    name={"fecha"}
                                                                                    value={formValues.fecha}
                                                                                    onChange={handleInputChange}
                                                                                  />
                                                                                </div>
                                          <div className="col-md-3">
                                                                                  <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Hora Inicial</label>
                                                                                  <TimePicker
                                                                                    name={"horaInicial"}
                                                                                    format="HH:mm"
                                                                                    value={initialDate}
                                                                                    onChange={handleTimeChange}
                                                                                    hideMinutes={(minute) => minute % 15 !== 0}
                                                                                    editable={false}
                                                                                  />
                                                                                </div>
                                          <div className="col-md-3" style={{ display: "none" }}>
                                                                                  <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Estado de Servicio</label>
                                                                                  <>
                                                                                    <input
                                                                                      onInput={(e) => {
                                                                                        e.target.value = e.target.value.toUpperCase()
                                                                                      }}
                                                                                      className={"form-control form-control-sm"}
                                                                                      readOnly={"readOnly"}
                                                                                      onChange={handleInputChange}
                                                                                      type={"hidden"}
                                                                                      name={"estado_nombre"}
                                                                                      id={"estado_nombre"}
                                                                                    />
                                                                                    <div className="input-group mb-3">
                                                                                      <input
                                                                                        onInput={(e) => {
                                                                                          e.target.value = e.target.value.toUpperCase()
                                                                                        }}
                                                                                        className={"form-control form-control-sm"}
                                                                                        readOnly={"readOnly"}
                                                                                        onChange={handleInputChange}
                                                                                        type={"text"}
                                                                                        name={"estado_nombre" + "_name"}
                                                                                        id={"estado_nombre" + "_name"}
                                                                                      />
                                                                                      <button
                                                                                        className="btn btn-outline-secondary btn-sm"
                                                                                        onClick={() => Buscar("estado_servicio", "id", "estado", "estado_nombre", "")}
                                                                                        type="button"
                                                                                        data-bs-toggle="modal"
                                                                                        data-bs-target="#ModalSelect"
                                                                                      >
                                                                                        <FontAwesomeIcon icon={faSearch} />
                                                                                      </button>
                                                                                    </div>
                                                                                  </>
                                                                                </div>
                                          <div className="col-md-3">
                                                                                  <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Numero Expediente</label>
                                                                                  <div className="input-group mb-3">
                                                                                    <input
                                                                                      className={"form-control form-control-sm"}
                                                                                      type={"text"}
                                                                                      name={"numeroExpediente"}
                                                                                      value={formValues.numeroExpediente}
                                                                                      onChange={handleInputChange}
                                                                                    />
                                                                                    <button
                                                                                      className="btn btn-outline-secondary btn-sm"
                                                                                      onClick={() => buscarExpediente()}
                                                                                      type="button"
                                                                                    >
                                                                                      <FontAwesomeIcon icon={faSearch} />
                                                                                    </button>
                                                                                  </div>
                                                                                </div>
                                          <div className="col-md-6">
                                                                                  <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Direccion Inicial</label>
                                                                                  <input
                                                                                    className={"form-control form-control-sm"}
                                                                                    type={"text"}
                                                                                    name={"direccionInicial"}
                                                                                    value={formValues.direccionInicial}
                                                                                    onChange={handleInputChange}
                                                                                  />
                                                                                </div>
                                          <div className="col-md-6">
                                                                                  <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Direccion Final</label>
                                                                                  <input
                                                                                    className={"form-control form-control-sm"}
                                                                                    type={"text"}
                                                                                    name={"direccionFinal"}
                                                                                    value={formValues.direccionFinal}
                                                                                    onChange={handleInputChange}
                                                                                  />
                                                                                </div>
                                          <div className="col-md-12">
                                                                                  <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Observaciones</label>
                                                                                  <textarea
                                                                                    className={"form-control form-control-sm"}
                                                                                    name={"obs"}
                                                                                    value={formValues.obs}
                                                                                    onChange={handleInputChange}
                                                                                  ></textarea>
                                                                                </div>
                                        </div>
                                      </fieldset>
                                      <fieldset className="border p-3 mb-3 w-100 border-secondary" style={{ borderRadius: '5px' }}>
                                        <legend className="w-auto px-2" style={{ fontSize: '1rem', fontWeight: 'bold', color: '#2c3e50' }}>DATOS DE USUARIO Y/O RESPONSABLE</legend>
                                        <div className="row g-2">
                                          <div className="col-md-4">
                                                                                  <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Identificacion</label>
                                                                                  <>
                                                                                    <input
                                                                                      onInput={(e) => {
                                                                                        e.target.value = e.target.value.toUpperCase()
                                                                                      }}
                                                                                      className={"form-control form-control-sm"}
                                                                                      onChange={handleInputChange}
                                                                                      type={"hidden"}
                                                                                      name={"identificacion_usuario"}
                                                                                      id={"identificacion_usuario"}
                                                                                    />
                                                                                    <div className="input-group mb-3">
                                                                                      <input
                                                                                        onInput={(e) => {
                                                                                          e.target.value = e.target.value.toUpperCase()
                                                                                        }}
                                                                                        className={"form-control form-control-sm"}
                                                                                        onChange={handleInputChange}
                                                                                        type={"text"}
                                                                                        name={"identificacion_usuario" + "_name"}
                                                                                        id={"identificacion_usuario" + "_name"}
                                                                                      />
                                                                                      <button
                                                                                        className="btn btn-outline-secondary btn-sm"
                                                                                        onClick={() =>
                                                                                          BuscarIdentificacion("tipo_recorrido", "id", "nombre", "tipo_nombre")
                                                                                        }
                                                                                        type="button"
                                                                                      >
                                                                                        <FontAwesomeIcon icon={faSearch} />
                                                                                      </button>
                                                                                    </div>
                                                                                  </>
                                                                                </div>
                                          <div className="col-md-4">
                                                                                  <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Nombre</label>
                                                                                  <input
                                                                                    className={"form-control form-control-sm"}
                                                                                    type={"text"}
                                                                                    name={"nombreUsuario"}
                                                                                    value={formValues.nombreUsuario}
                                                                                    onChange={handleInputChange}
                                                                                  />
                                                                                </div>
                                          <div className="col-md-4">
                                                                                  <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Apellido</label>
                                                                                  <input
                                                                                    className={"form-control form-control-sm"}
                                                                                    type={"text"}
                                                                                    name={"apellidoUsuario"}
                                                                                    value={formValues.apellidoUsuario}
                                                                                    onChange={handleInputChange}
                                                                                  />
                                                                                </div>
                                          <div className="col-md-4">
                                                                                  <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Direccion</label>
                                                                                  <input
                                                                                    className={"form-control form-control-sm"}
                                                                                    type={"text"}
                                                                                    name={"direccionUsuario"}
                                                                                    value={formValues.direccionUsuario}
                                                                                    onChange={handleInputChange}
                                                                                  />
                                                                                </div>
                                          <div className="col-md-4">
                                                                                  <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Telefono</label>
                                                                                  <input
                                                                                    className={"form-control form-control-sm"}
                                                                                    type={"text"}
                                                                                    name={"telefonoUsuario"}
                                                                                    value={formValues.telefonoUsuario}
                                                                                    onChange={handleInputChange}
                                                                                  />
                                                                                </div>
                                          <div className="col-md-4">
                                                                                  <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Correo</label>
                                                                                  <input
                                                                                    className={"form-control form-control-sm"}
                                                                                    type={"text"}
                                                                                    name={"correoUsuario"}
                                                                                    value={formValues.correoUsuario}
                                                                                    onChange={handleInputChange}
                                                                                  />
                                                                                </div>
                                          <div className="col-md-4">
                                                                                  <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Nombre Responsable Servicio</label>
                                                                                  <input
                                                                                    className={"form-control form-control-sm"}
                                                                                    type={"text"}
                                                                                    name={"nombreLogistica"}
                                                                                    value={formValues.nombreLogistica}
                                                                                    onChange={handleInputChange}
                                                                                  />
                                                                                </div>
                                          <div className="col-md-4">
                                                                                  <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Cargo Responsable Servicio</label>
                                                                                  <input
                                                                                    className={"form-control form-control-sm"}
                                                                                    type={"text"}
                                                                                    name={"cargoLogistica"}
                                                                                    value={formValues.cargoLogistica}
                                                                                    onChange={handleInputChange}
                                                                                  />
                                                                                </div>
                                          <div className="col-md-4">
                                                                                  <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Celular Responsable Servicio</label>
                                                                                  <input
                                                                                    className={"form-control form-control-sm"}
                                                                                    type={"text"}
                                                                                    name={"numeroContacto"}
                                                                                    value={formValues.numeroContacto}
                                                                                    onChange={handleInputChange}
                                                                                  />
                                                                                </div>
                                        </div>
                                      </fieldset>
                                      <fieldset className="border p-3 mb-3 w-100 border-secondary" style={{ borderRadius: '5px' }}>
                                        <div className="row g-2">
                                          <div className="col-md-4">
                                                                                  <label className="form-label text-secondary fw-semibold mb-1" style={{ fontSize: '0.85rem' }}>Cantidad</label>
                                                                                  <input
                                                                                    className={"form-control form-control-sm"}
                                                                                    type={"number"}
                                                                                    name={"cantidad"}
                                                                                    value={formValues.cantidad}
                                                                                    onChange={handleInputChange}
                                                                                    min="1"
                                                                                  />
                                                                                  {CantidadParece == true ? (
                                                                                    <>
                                                                                      <a onClick={openModal} className="btn btn-success mt-4">
                                                                                        Seguir Editando Masivo
                                                                                      </a>
                                                                                    </>
                                                                                  ) : (
                                                                                    ""
                                                                                  )}
                                                                                </div>
                                          <div className="col-md-4">
                                                                                  <label>Aumentar Posición</label>
                                                                                  <div className="form-check mt-2">
                                                                                    <input
                                                                                      className="form-check-input"
                                                                                      type="checkbox"
                                                                                      id="aumentarPosicion"
                                                                                      checked={incrementPosition}
                                                                                      onChange={(e) => setIncrementPosition(e.target.checked)}
                                                                                    />
                                                                                    <label className="form-check-label" htmlFor="aumentarPosicion">
                                                                                      Incrementar posicion
                                                                                    </label>
                                                                                  </div>
                                                                                </div>
                                        </div>
                                      </fieldset>
                                      <div className="w-100 mt-2">
                                        <a onClick={saveItem} className="btn btn-outline-dark w-100 fw-bold border-2">GUARDAR</a>
                                      </div>
                                      </div>
                                    </>
                                  ) : (
                                    Tabla.map((row, i) =>
                                      fila.pestana == row.pestana ? (
                                        row.nombre_campo != "id" ? (
                                          <div
                                            className={`col-md-${row.columna} ${row.alineacion}  ${row.nombre_titulo !== "CATEGORIA" && row.nombre_tabla == "vehiculo" ? "" : ""}  ${row.campo_propio === "No" ? "propio-no" : "propio-si"} ${row.campo_contratista === "No" ? "contratista-no" : "contratista-si"}  `}
                                            id={`${row.nombre_campo}-div`}
                                            key={i}
                                          >
                                            {row.tipo_dato == "blob" ? (
                                              <div className="gallery my-gallery card-body row" itemscope="">
                                                <figure
                                                  className="col-xl-12 col-md-12 col-12"
                                                  itemprop="associatedMedia"
                                                  itemscope=""
                                                >
                                                  <a href="#" itemprop="contentUrl" data-size="1600x950">
                                                    <iframe
                                                      className="img-thumbnail"
                                                      id={"img" + row.nombre_campo}
                                                      src="https://nosso.com/public/images/tipoproducto/default.jpg"
                                                      itemprop="thumbnail"
                                                      alt="..."
                                                    ></iframe>
                                                  </a>
                                                  <figcaption itemprop="caption description">
                                                    {row.orden}.{row.nombre_titulo}
                                                  </figcaption>
                                                </figure>
                                              </div>
                                            ) : (
                                              <label htmlFor={row.nombre_titulo}>
                                                {row.orden}.{row.nombre_titulo}{" "}
                                                {row.obligatorio == "1" ? <span className="text-danger">*</span> : ""}
                                                {row.obligatorio_caracol == "Si" ? (
                                                  <span className="text-primary" style={{ fontWeight: "bold" }}>
                                                    Caracol
                                                  </span>
                                                ) : (
                                                  ""
                                                )}
                                              </label>
                                            )}

                                            {row.trae_tabla === null ? (
                                              row.tipo_dato == "text" ? (
                                                <textarea
                                                  className={"form-control form-control-sm"}
                                                  readOnly={row.campo_editable == "Si" ? "" : "readOnly"}
                                                  onInput={(e) => {
                                                    e.target.value = e.target.value.toUpperCase()
                                                  }}
                                                  name={row.nombre_campo}
                                                  id={row.nombre_campo}
                                                ></textarea>
                                              ) : (
                                                <input
                                                  className={"form-control form-control-sm"}
                                                  onInput={(e) => {
                                                    if (row.tipo_dato !== "email") {
                                                      e.target.value = e.target.value.toUpperCase()
                                                    }
                                                  }}
                                                  readOnly={row.campo_editable == "Si" ? "" : "readOnly"}
                                                  type={
                                                    row.tipo_dato === "int"
                                                      ? "number"
                                                      : row.tipo_dato === "date"
                                                        ? "date"
                                                        : row.tipo_dato === "time"
                                                          ? "time"
                                                          : row.tipo_dato === "blob"
                                                            ? "file"
                                                            : row.tipo_dato === "email"
                                                              ? "email"
                                                              : row.tipo_dato === "datetime"
                                                                ? "datetime-local"
                                                                : "text"
                                                  }
                                                  name={row.nombre_campo}
                                                  id={row.nombre_campo}
                                                />
                                              )
                                            ) : row.trae_tabla == "" ? (
                                              <input
                                                className={"form-control form-control-sm"}
                                                onInput={(e) => {
                                                  e.target.value = e.target.value.toUpperCase()
                                                }}
                                                readOnly={row.campo_editable == "Si" ? "" : "readOnly"}
                                                type={
                                                  row.tipo_dato === "int"
                                                    ? "number"
                                                    : row.tipo_dato === "date"
                                                      ? "date"
                                                      : row.tipo_dato === "time"
                                                        ? "time"
                                                        : row.tipo_dato === "blob"
                                                          ? "file"
                                                          : row.tipo_dato === "datetime"
                                                            ? "datetime-local"
                                                            : "text"
                                                }
                                                name={row.nombre_campo}
                                                id={row.nombre_campo}
                                              />
                                            ) : (
                                              <>
                                                <input
                                                  onInput={(e) => {
                                                    e.target.value = e.target.value.toUpperCase()
                                                  }}
                                                  className={"form-control form-control-sm"}
                                                  readOnly={row.campo_editable == "Si" ? "" : "readOnly"}
                                                  type={"hidden"}
                                                  name={row.nombre_campo}
                                                  id={row.nombre_campo}
                                                />
                                                <div className="input-group mb-3">
                                                  <input
                                                    onInput={(e) => {
                                                      e.target.value = e.target.value.toUpperCase()
                                                    }}
                                                    className={"form-control form-control-sm"}
                                                    readOnly={"readOnly"}
                                                    type={"text"}
                                                    name={row.nombre_campo + "_name"}
                                                    id={row.nombre_campo + "_name"}
                                                  />
                                                  <button
                                                    className="btn btn-outline-secondary btn-sm"
                                                    onClick={() =>
                                                      Buscar(
                                                        row.trae_tabla,
                                                        row.trae_value,
                                                        row.trae_campo,
                                                        row.nombre_campo,
                                                        '',
                                                      )
                                                    }
                                                    type="button"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#ModalSelect"
                                                  >
                                                    <FontAwesomeIcon icon={faSearch} />
                                                  </button>
                                                </div>
                                              </>
                                            )}
                                          </div>
                                        ) : (
                                          <input
                                            onInput={(e) => {
                                              e.target.value = e.target.value.toUpperCase()
                                            }}
                                            type="hidden"
                                            name={row.nombre_campo}
                                            id={row.nombre_campo}
                                            placeholder={row.nombre_campo}
                                          />
                                        )
                                      ) : (
                                        ""
                                      ),
                                    )
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                </div>

                {showAdditionalFormsModal && (
                  <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                    <div className="modal-dialog modal-xl">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Formularios Adicionales</h5>
                          <button
                            type="button"
                            className="btn-close"
                            onClick={handleCloseAdditionalFormsModal}
                          ></button>
                        </div>
                        <div className="modal-body">
                          {additionalFormsData.map((formData, index) => (
                            <div className="row p-4" key={index}>
                              <h5>Formulario {index + 1}</h5>

                              <div className="col-md-4">
                                <label>Fecha</label>
                                <input
                                  className={"form-control form-control-sm"}
                                  type={"date"}
                                  name={"fecha"}
                                  value={formData.fecha}
                                  onChange={(e) => handleAdditionalFormInputChange(index, e)}
                                />
                              </div>

                              <div className="col-md-4">
                                <label>Hora Inicial (Informativo)</label>
                                <br />
                                <input
                                  type="text"
                                  className={"form-control form-control-sm"}
                                  value={formData.horaInicial || ""}
                                  readOnly
                                />
                              </div>

                              <div className="col-md-4">
                                <label>Hora Inicial Modificar</label>
                                <br />
                                <TimePicker
                                  name={"horaInicial"}
                                  format="HH:mm"
                                  value={formData.horaInicial}
                                  onChange={(time) => handleAdditionalFormTimeChange(index, time)}
                                  hideMinutes={(minute) => minute % 15 !== 0}
                                  editable={false}
                                />
                              </div>

                              <div className="col-md-4">
                                <label>Numero Expediente</label>
                                <input
                                  className={"form-control form-control-sm"}
                                  type={"text"}
                                  name={"numeroExpediente"}
                                  value={formData.numeroExpediente}
                                  onChange={(e) => handleAdditionalFormInputChange(index, e)}
                                />
                              </div>

                              <div className="col-md-4">
                                <label>Dirección Inicial</label>
                                <input
                                  className={"form-control form-control-sm"}
                                  type={"text"}
                                  name={"direccionInicial"}
                                  value={formData.direccionInicial}
                                  onChange={(e) => handleAdditionalFormInputChange(index, e)}
                                />
                              </div>

                              <div className="col-md-4">
                                <label>Dirección Final</label>
                                <input
                                  className={"form-control form-control-sm"}
                                  type={"text"}
                                  name={"direccionFinal"}
                                  value={formData.direccionFinal}
                                  onChange={(e) => handleAdditionalFormInputChange(index, e)}
                                />
                              </div>

                              <div className="col-md-4">
                                <label>Valor Servicio</label>
                                <input
                                  className={"form-control form-control-sm"}
                                  type={"text"}
                                  name={"valorServicio"}
                                  value={formData.valorServicio}
                                  onChange={(e) => handleAdditionalFormInputChange(index, e)}
                                />
                              </div>


                              <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea
                                  className={"form-control form-control-sm"}
                                  name={"obs"}
                                  value={formData.obs}
                                  onChange={(e) => handleAdditionalFormInputChange(index, e)}
                                ></textarea>
                              </div>
                              <hr />
                            </div>
                          ))}
                        </div>
                        <div className="modal-footer">
                          <button type="button" className="btn btn-secondary" onClick={handleCloseAdditionalFormsModal}>
                            Cerrar
                          </button>
                          <button type="button" className="btn btn-primary" onClick={handleSaveAdditionalForms}>
                            Guardar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {showAdditionalFormsModal && <div className="modal-backdrop fade show"></div>}

                {NombreTabla != "mantenimientos" ? (
                  <div className="modal-footer">
                    {NombreTabla != "servicio" ? (
                      <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        disabled={InactivarBoton == 0 ? false : true}
                        onClick={() => save()}
                      >
                        Guardar Registro.
                      </button>
                    ) : (
                      ""
                    )}
                    <button type="button" className="btn btn-danger btn-sm" data-bs-dismiss="modal">
                      Cerrar
                    </button>
                    {NombreTabla == "vehiculo" ? (
                      <button type="button" className="btn btn-success btn-sm" onClick={() => savecaracol()}>
                        Guardar en caracol
                      </button>
                    ) : (
                      ""
                    )}
                    {NombreTabla == "conductores" ? (
                      <button type="button" className="btn btn-success btn-sm" onClick={() => savecaracolconductores()}>
                        Guardar en caracol
                      </button>
                    ) : (
                      ""
                    )}
                    {NombreTabla == "fuec" ? (
                      Boton == "1" ? (
                        <button
                          type="button"
                          className="btn btn-secondary btn-sm"
                          data-bs-toggle="modal"
                          data-bs-target="#ModalImprimir"
                        >
                          {" "}
                          <FontAwesomeIcon icon={faPrint} /> Imprimir FUEC
                        </button>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  <div className="modal-footer">
                    <button type="button" className="btn btn-primary btn-sm" onClick={() => saveProgramacion()}>
                      Guardar Registro.
                    </button>
                    <button type="button" className="btn btn-danger btn-sm" data-bs-dismiss="modal">
                      Cerrar
                    </button>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>


      <div className="modal fade" id="ModalSelect" tabIndex={-1} aria-labelledby="ModalSelectLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content bg-dark bg-gradient ">
            <div className="modal-header">
              <h5 className="modal-title" id="ModalSelectLabel">
                Seleccione{" "}
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body">
              <div>
                <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="pills-home-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-home"
                      type="button"
                      role="tab"
                      aria-controls="pills-home"
                      aria-selected="true"
                    >
                      Listado
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="pills-profile-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-profile"
                      type="button"
                      role="tab"
                      aria-controls="pills-profile"
                      aria-selected="false"
                    >
                      + Registro
                    </button>
                  </li>
                </ul>
                <div className="tab-content" id="pills-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="pills-home"
                    role="tabpanel"
                    aria-labelledby="pills-home-tab"
                  >
                    <div className="card">
                      <div className="card-body">
                        <div className="row g-3 table-responsive" id="f1">
                          <input
                            type="text"
                            placeholder="Buscar por descripción..."
                            className="form-control mb-3"
                            value={searchTerm1}
                            onChange={(e) => setSearchTerm1(e.target.value)}
                          />
                          <table className="table table-hover table-condensed table-sm">
                            <thead className="thead-inverse">
                              <tr>
                                <th className="align-middle">ID</th>
                                <th className="align-middle">DESCRIPCION</th>
                              </tr>
                            </thead>
                            <tbody>
                              {isLoadingOpen ? (
                                <div className="text-center">
                                  <p>Cargando...</p>
                                  <div className="spinner-border" role="status">
                                    <span className="sr-only">Cargando...</span>
                                  </div>
                                </div>
                              ) : (
                                filteredItems.map((item) => (
                                  <tr key={item.id}>
                                    <td>{item.id}</td>
                                    <td>
                                      <a
                                        onClick={() => Seleccionar(item.id, item.nombre, item.tabla)}
                                        data-bs-dismiss="modal"
                                      >
                                        <ins>{item.nombre}</ins>
                                      </a>
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                    <div className="row" id="f1">
                      <h4>Registro</h4>
                      <div>
                        <label>Nombre</label>
                        <input type="text" className="form-control" id="extra" name="extra" />
                      </div>
                      <div className="mb-3">
                        <br></br>
                        <input
                          type="button"
                          className="btn btn-primary"
                          id="extra_btn"
                          value={"Agregar"}
                          onClick={() => AddExtra()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
      {showTarifaModal && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable text-dark">
            <div className="modal-content text-dark">
              <div className="modal-header bg-success text-white">
                <h5 className="modal-title">
                  <FontAwesomeIcon icon={faDollarSign} className="me-2" />
                  Seleccionar Tarifa para Asignar
                </h5>
                <button type="button" className="btn-close btn-close-white" onClick={cerrarModalTarifas}></button>
              </div>
              <div className="modal-body bg-light p-3">
                <div className="mb-3">
                  <div className="input-group input-group-sm">
                    <span className="input-group-text bg-white">
                      <FontAwesomeIcon icon={faSearch} />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Buscar por vehículo, modalidad, disponibilidad o valor..."
                      value={filtroModalTarifa}
                      onChange={(e) => setFiltroModalTarifa(e.target.value)}
                    />
                  </div>
                </div>

                <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                  <table className="table table-hover table-sm table-bordered bg-white mb-0" style={{ fontSize: '0.85rem' }}>
                    <thead className="table-success position-sticky top-0 shadow-sm" style={{ zIndex: 1 }}>
                      <tr className="text-center align-middle">
                        <th style={{ width: '10%' }}>Acción</th>
                        <th style={{ width: '25%' }}>Vehículo</th>
                        <th style={{ width: '15%' }}>Modalidad</th>
                        <th style={{ width: '25%' }}>Disponibilidad</th>
                        <th style={{ width: '12%' }}>Valor Sin IVA</th>
                        <th style={{ width: '13%' }}>Costo Tercero</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(() => {
                        let filtered = tarifasCliente;

                        if (filtroModalTarifa) {
                          const term = filtroModalTarifa.toLowerCase();
                          filtered = filtered.filter(t => 
                            String(t.vehiculo || '').toLowerCase().includes(term) ||
                            String(t.modalidad || '').toLowerCase().includes(term) ||
                            String(t.disponibilidad || '').toLowerCase().includes(term) ||
                            String(t.valor_sin_iva || '').toLowerCase().includes(term) ||
                            String(t.costo_tercero || '').toLowerCase().includes(term)
                          );
                        }

                        if (cargandoTarifas) {
                            return (
                                <tr><td colSpan="6" className="text-center py-4 text-muted"><FontAwesomeIcon icon={faSpinner} spin className="me-2" /> Cargando tarifas...</td></tr>
                            );
                        }
                        
                        if (filtered.length === 0) {
                          return (
                            <tr><td colSpan="6" className="text-center py-4 text-muted">No coinciden tarifas con el criterio de búsqueda.</td></tr>
                          );
                        }

                        return filtered.map((t) => (
                          <tr key={t.id} className="align-middle">
                            <td className="text-center">
                              <button
                                type="button"
                                className="btn btn-success btn-sm px-3 fw-bold"
                                onClick={() => seleccionarYActualizarTarifa(t)}
                              >
                                Seleccionar
                              </button>
                            </td>
                            <td className="text-dark">{t.vehiculo || 'N/A'}</td>
                            <td className="text-dark">{t.modalidad}</td>
                            <td className="text-dark">{t.disponibilidad}</td>
                            <td className="text-end fw-bold text-dark">${Number(t.valor_sin_iva || 0).toLocaleString()}</td>
                            <td className="text-end fw-bold text-dark">${Number(t.costo_tercero || 0).toLocaleString()}</td>
                          </tr> 
                        ));
                      })()}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="modal-footer bg-light">
                <button type="button" className="btn btn-secondary btn-sm" onClick={cerrarModalTarifas}>
                  <FontAwesomeIcon icon={faTimes} className="me-1" /> Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  )
}

export default React.memo(Index);
